import { render, staticRenderFns } from "./RightFixedPanel.vue?vue&type=template&id=563bd718&scoped=true"
import script from "./RightFixedPanel.vue?vue&type=script&lang=js"
export * from "./RightFixedPanel.vue?vue&type=script&lang=js"
import style0 from "./RightFixedPanel.vue?vue&type=style&index=0&id=563bd718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bd718",
  null
  
)

export default component.exports